import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {VatTuService} from '@entities/vat-tu/vat-tu.service';
import {JhiEventManager} from 'ng-jhipster';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-vat-tu-import',
  templateUrl: './vat-tu-import.component.html',
})
export class VatTuImportComponent implements OnInit {
  fileToUpload: File;
  error: string;
  isSaving: boolean;
  constructor(
    private dialogRef: MatDialogRef<VatTuImportComponent>,
    private vattuService: VatTuService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private translate: TranslateService,
  ) {
    this.isSaving = true;
    this.fileToUpload = null;
    this.error = '';
  }

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.vat-tu.vat-tu-import.Import vật tư_title',
      ),
    );
  }

  handleFileInput(files: FileList) {
    if (files.length > 0) {
      this.isSaving = false;
      this.fileToUpload = files.item(0);
    } else {
      this.isSaving = true;
    }
  }

  checkValidFileImport() {
    const extension = this.fileToUpload.name.split('.').pop();
    if (extension === 'csv' || extension === 'xlsx') {
      return true;
    } else {
      return false;
    }
  }
  uploadFileToActivity() {
    if (this.checkValidFileImport() === true) {
      this.vattuService.import(this.fileToUpload).subscribe(
        (data) => {
          this.onSaveSuccess(data);
        },
        (error) => {
          this.onSaveError();
        },
      );
    } else {
      this.isSaving = true;
      this.error = this.translate.instant(
        'entities.vat-tu.vat-tu-import.Định dạng file không đúng!_error_message',
      );
    }
  }

  private onSaveSuccess(result) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'vattuListModification',
      content: 'VatTu',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-vat-tu-popup',
  template: '',
})
export class VatTuImportPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<VatTuImportComponent>;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRouteVatTu();
  }

  ngOnDestroy() {
    this.dialogRef = null;
    this.titleService.setTitle(
      this.translate.instant(
        'entities.vat-tu.vat-tu-import.Danh sách vật tư_title',
      ),
    );
  }

  activatedRouteVatTu() {
    setTimeout(() => {
      this.dialogRef = this.dialog.open(VatTuImportComponent, {
        disableClose: true,
        width: '380px',
      });
      this.dialogRef.afterClosed().subscribe(
        (result) => {
          this.router.navigate([{outlets: {popup: null}}], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
          });
        },
        (reason) => {
          this.router.navigate([{outlets: {popup: null}}], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
          });
        },
      );
    }, 10);
  }
}
